
import { defineComponent, computed, PropType } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { Conversation } from '@/models/conversation'
import { SYSTEM_MESSAGES } from '@/config/variables'
export default defineComponent({
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n()
    const conversationSubitle = computed(() => {
      return SYSTEM_MESSAGES.includes(props.conversation.lastMessage.text)
        ? t(props.conversation.lastMessage.text)
        : props.conversation.lastMessage.text
    })
    const formatDate = (date: number) => {
      return dayjs(date).format('MM/DD/YY hh:mm a')
    }
    return {
      conversationSubitle,
      //conversation,
      formatDate
    }
  }
})
